<template>
<div >
  <div>
    <div class="accordion -simple row js-accordion">
      <div
        v-for="(item, index) in accordionItems"
        :key="`accordion-item-${index}`"
        class="col-12"
      >
        <div class="accordion__item pt-15">
          <div
            class="accordion__button pb-15 d-flex items-center"
            :class="{ 'is-active': activeItems.includes(index) }"
            @click="toggleAccordion(index)"
          >
            <div
  class="button uppercase text-dark-1"
  :class="company.company_key === 'kineticestateagents'
    ? 'text-24 md:text-22 !tw-font-medium'
    : 'text-18 md:text-16 fw-500'"
  style="color: var(--c-text_primary);"
>
              <span v-if="showNumbers">{{ index + 1 }}- </span>{{ item.title }}
            </div>

            <div
              class="accordion__icon size-40 flex-center bg-light-2 rounded-full mr-20"
              :class="{ 'is-active': activeItems.includes(index) }"
            >
              <i class="icon-plus" style="color: var(--c-text_primary);"></i>
              <i class="icon-minus-1" style="color: var(--c-text_primary);"></i>
            </div>
          </div>

          <div
            class="accordion__content"
            :class="{ 'is-active': activeItems.includes(index) }"
          >
            <div class="pt-30 mb-15">
              <div
                v-if="item.html"
                class="text-18 md:text-16"
                v-html="item.content"
              ></div>
              <p
                v-else
                class="text-18 md:text-16"
              >
                {{ item.content }}
              </p>
              
              <!-- Slot for custom content -->
              <slot
                :name="`item-${index}`"
                :item="item"
                :index="index"
                :is-active="activeItems.includes(index)"
              ></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script lang="ts">
type AccordionItem = {
  title: string
  content: string
  html?: boolean
}

export default defineNuxtComponent({
  name: 'Theme7Accordion',
  
  props: {
    items: {
      type: Array as PropType<AccordionItem[]>,
      default: () => [
        {
          title: 'DO YOU HAVE A STORE IN EUROPE?',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
          html: false
        },
        {
          title: 'WHAT ACCOMODATIONS ARE MADE FOR VISITORS WITH DISABILITIES?',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
          html: false
        },
        {
          title: 'CAN I PAY WITH VISA INSPIRE CARD?',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
          html: false
        },
        {
          title: 'WHAT SECURITY PRECAUTIONS DO YOU TAKE?',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
          html: false
        },
        {
          title: 'WHAT WOMEN WANT IN THE RESTROOM',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
          html: false
        }
      ]
    },
    
    allowMultiple: {
      type: Boolean,
      default: false
    },
    
    showNumbers: {
      type: Boolean,
      default: true
    },
    
    initialOpenItems: {
      type: Array as PropType<number[]>,
      default: () => []
    }
  },

  data() {
    return {
      activeItems: [] as number[]
    }
  },

  computed: {
    accordionItems(): AccordionItem[] {
      return this.items
    }
  },

  mounted() {
    this.activeItems = [...this.initialOpenItems]
    this.initializeAccordion()
  },

  methods: {
    toggleAccordion(index: number) {
      if (this.allowMultiple) {
        // Multiple items can be open
        const activeIndex = this.activeItems.indexOf(index)
        if (activeIndex > -1) {
          this.activeItems.splice(activeIndex, 1)
        } else {
          this.activeItems.push(index)
        }
      } else {
        // Only one item can be open
        if (this.activeItems.includes(index)) {
          this.activeItems = []
        } else {
          this.activeItems = [index]
        }
      }
      
      this.$emit('accordion-toggle', {
        index,
        item: this.accordionItems[index],
        isOpen: this.activeItems.includes(index),
        activeItems: [...this.activeItems]
      })
    },

    initializeAccordion() {
      // Add any initialization logic here if needed
      // The existing accordion functionality should work with the dynamic structure
    },

    openItem(index: number) {
      if (!this.activeItems.includes(index)) {
        if (this.allowMultiple) {
          this.activeItems.push(index)
        } else {
          this.activeItems = [index]
        }
      }
    },

    closeItem(index: number) {
      const activeIndex = this.activeItems.indexOf(index)
      if (activeIndex > -1) {
        this.activeItems.splice(activeIndex, 1)
      }
    },

    closeAll() {
      this.activeItems = []
    },

    openAll() {
      if (this.allowMultiple) {
        this.activeItems = this.accordionItems.map((_, index) => index)
      }
    }
  }
});
</script>